module.exports = __webpack_public_path__ + "static/img/signup.log.a42ad75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/signup.log.png
// module id = c9Xz
// module chunks = 1